export default {
  config: {
    platform: "LEED GLOBAL CAPITAL LIMITED",
    imagesFile: "cointiger"
  }
};



// WEBPACK FOOTER //
// ./src/config.js